module.exports = __webpack_public_path__ + "about-us-b998e096/upsell_icon_green-0d5d5c13b6f65d5bf95ec15dbe592bcd.png";